export const tools = [
    {
        preview: "\\(a'\\)",
        value: "替换'"
    },
    {
        preview: "\\(a''\\)",
        value: "替换''"
    },
    {
        preview: "\\(\\frac{a}{b}\\)",
        value: "\\frac{替换分子}{替换分母}"
    },
    {
        preview: "\\(x^y\\)",
        value: "{左值}^{右上标}"
    },
    {
        preview: "\\(x_y\\)",
        value: "{左值}_{右下标}"
    }
]
